import { IconDefinitions } from '../../../components';

export const CTEYE_COMMANDS = [
  {
    name: 'PurgeHeartbeats',
    apiCommandName: 'PurgeHeartbeats',
    displayName: 'Purge Old Heartbeats',
    description: 'Permanently delete heartbeat records older than a specified number of days',
    icon: IconDefinitions.purge,
  },
  {
    name: 'SetHeartbeatInterval',
    apiCommandName: 'SaveConfiguration',
    displayName: 'Set Heartbeat Interval',
    description: 'Change how frequently the device sends heartbeats (in seconds)',
    icon: IconDefinitions.clock,
  },
  {
    name: 'SetTargetImportRows',
    apiCommandName: 'SaveConfiguration',
    displayName: 'Set Target Import Rows',
    description: 'Set the target number of rows per import. The group size is dynamically calculated based on this target and the source data size.',
    icon: IconDefinitions.hashtag,
  },
  {
    name: 'SetRollingWindowSize',
    apiCommandName: 'SaveConfiguration',
    displayName: 'Set Rolling Average Window Size',
    description: 'Set how many FLW data points the device averages over for the live rolling average deviation gauge',
    icon: IconDefinitions.chartLineUp,
  },
] as const;

export type CTEyeCommandName = typeof CTEYE_COMMANDS[number]['name'];

export const getCtEyeCommand = (name: CTEyeCommandName) =>
  CTEYE_COMMANDS.find(c => c.name === name)!;

/** There are currently commands made in the backend that will not be used in the FE
 *  so we filter out the ones we want the user to see*/
export const getKnownInstalledCommands = (apiCommandNames: string[]) =>
  CTEYE_COMMANDS.filter(cmd => apiCommandNames.includes(cmd.apiCommandName));
